// extracted by mini-css-extract-plugin
module.exports = {"mid":"Github_mid__1KMBW","margin":"Github_margin__2wBe_","inner":"Github_inner__7Larg"};